export default (pathname) => window.location.pathname === pathname;
